import { ApiProperty } from "@nestjs/swagger";

export class GrnAbstractRequest {
    
    @ApiProperty()

    fromDate: Date;
    
    @ApiProperty()

    toDate: Date;

    @ApiProperty()

    harvestType: String;

    @ApiProperty()
    reweighmentFromDate: Date;
    
    @ApiProperty()
    reweighmentToDate: Date;

    constructor(fromDate: Date, toDate: Date,harvestType: String) {
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.harvestType = harvestType;

    }
}